module.exports = __webpack_public_path__ + "img/noPhoto.d8531de8.jpeg";